import { HttpHeaders } from '@angular/common/http';
import { Component, HostListener, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { JSEncrypt } from 'jsencrypt';
import _lodash from 'lodash';
import { ApiService } from '../api.service';
import { DataService } from "../data.service";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  editForm: UntypedFormGroup;
  panelExpanded = false;
  userData: any;
  page: any = 0;
  totalPages: number;
  totalItems: any;
  itemsPerPage: any = 10;
  isLoading: boolean = false;
  midSecHt: any;
  noMoreCardText: any;

  giftCards: any = []
  constructor(
    private router: Router,
    private dataService: DataService,
    private apiService: ApiService,
  ) { }

  calculateHeight() {
    setTimeout(() => {
      let wh = window.innerHeight;
      let topSecHt = document.getElementById('topSec').offsetHeight;
      this.midSecHt = (wh - topSecHt);
    });
  };

  ngOnInit(): void {
    this.getAllGifrCards();
    this.calculateHeight();
  }

  processAfterGetCards() {
    _lodash.forEach(this.giftCards, (item: any) => {
      if (item.cardExpiry) item.expDate = item.cardExpiry;
      if (item.currentBalance) {
        item.decryptedCurrentBalance = item.currentBalance;
        item.decryptedCurrentBalance = Number(item.decryptedCurrentBalance);
      } else item.currentBalance = 0;
      if (item.cardDisplayName) item.decryptedCardDisplayName = item.cardDisplayName;
      if (item.maskedCardNo) item.decryptedMaskedCardNo = item.maskedCardNo.replace(/\W/gi, '').replace(/(.{4})/g, '$1 ')
      else {
        item.decryptedMaskedCardNo = 'xxxxxxxxxxxxxxxx';
        item.decryptedMaskedCardNo = item.decryptedMaskedCardNo.replace(/\W/gi, '').replace(/(.{4})/g, '$1 ')
      }
    });
  }

  protected paginateGiftCardList(data: any) {
    this.giftCards = this.giftCards.concat(data);
    if (this.giftCards && this.giftCards.length === 1) {
      this.router.navigate(['/card-detail', this.giftCards[0].id]);
    } else if (this.giftCards && this.giftCards.length > 1) {
      this.processAfterGetCards();
    }
  }

  getAllGifrCards() {
    this.isLoading = true;
    this.noMoreCardText = '';
    const apiData = {
      "apiType": "get",
      "apiExt": `giftCards?page=${this.page}&size=${this.itemsPerPage}&sort=id,asc`,
    };
    this.apiService.customGetApiCall({}, apiData).then((res: any) => {
      if (res) {
        this.totalItems = parseInt(res.headers['X-Total-Count']);
        this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
        if (res.data && res.data.length > 0) {
          this.paginateGiftCardList(res.data);
        }
      } else {
        this.isLoading = false;
        this.noMoreCardText = "No Cards available!"
      }
    }, (error) => {
      this.isLoading = false;
    });
  }

  getstatusBg(card: any) {
    if (card.giftCardStatus === 'LOCKED' || card.giftCardStatus === 'BLOCKED') return 'red';
  }

  viewCardDetail(card: any) {
    this.router.navigate(['/card-detail', card.id]);
  }

  logOut() {
    this.apiService.logOut();
    this.panelExpanded = false;
  }

  onScroll() {
    this.isLoading = true;
    this.page++;
    if (this.page > this.totalPages - 1) {
      this.isLoading = false;
      this.page = this.totalPages;
      this.noMoreCardText = "No more Cards available!";
    }
    else {
      this.noMoreCardText = '';
      this.getAllGifrCards();
    }
  }
}
